import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

const createAxiosInstance = (
  baseURL: string,
  config?: AxiosRequestConfig
): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    withCredentials: true,
    ...config,
  });

  instance.defaults.headers.put['Content-Type'] =
    'application/x-www-form-urlencoded';

  instance.defaults.timeout = 60000;
  return instance;
};

export const baseInstance = createAxiosInstance(
  process.env.REACT_APP_DEV_URI || ''
);
export const ticketmanInstance = createAxiosInstance(
  process.env.REACT_APP_TICKETMAN_URI || ''
);
export const nodeInstance = createAxiosInstance(
  process.env.REACT_APP_NODE_PROD_URI || '',
  {
    withCredentials: false,
  }
);
export const nodedevInstance = createAxiosInstance(
  process.env.REACT_APP_NODE_DEV_URI || '',
  {
    withCredentials: false,
  }
);

export const nodeManchantInstance = createAxiosInstance(
  process.env.REACT_APP_MERCHANT_NODE_URI || '',
  {
    withCredentials: false,
  }
);
export const phoneValidationInstance = createAxiosInstance(
  process.env.REACT_APP_VALIDATE_PHONENUMBER || ''
);
export const alphaInstance = createAxiosInstance(
  process.env.REACT_APP_ALPHA_URI || ''
);
export const alphaLoginInstance = createAxiosInstance(
  process.env.REACT_APP_ALPHA_AUTH || '',
  {
    withCredentials: false,
  }
);
export const alphaOrderInstance = createAxiosInstance(
  process.env.REACT_APP_ALPHA_ORDER || ''
);
export const agilityInstance = createAxiosInstance(
  process.env.REACT_APP_AGILITY_TEST_URL || ''
);

phoneValidationInstance.defaults.headers.put['Content-Type'] =
  'application/json';
